export default "__VITE_ASSET__hFrqRMfT__"